import initBookmakerRegPanel from 'rp-betting-special-offer';
import initGuiGuide from 'rp-gui-guide';
import popup, { backLink } from 'rp-popup';
import rpUrlNavigationPrefs from 'rp-url-navigation-prefs';
/**
 * @NOTE: Have to import something from 'rp-navigation' in order to execute embedded init logic!!!
 */
import { authRender } from 'rp-navigation'; // eslint-disable-line no-unused-vars
import initAds from './initAds';
import initPrices from './initPrices';

export default {
    beforeRender() {
        initGuiGuide({
            // transform svg to inline
            svg: { polyfill: true },
        });
    },
    afterRender() {
        // Ensure auth is rendered after DOM is ready
        authRender();
        initBookmakerRegPanel();
        initAds();
        initPrices();
        popup();
        backLink();
        rpUrlNavigationPrefs();
    },
};



// WEBPACK FOOTER //
// ./src/js/rpLibs.js